import Avatar from "./basic-12-avatar.png";
import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic12 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #12";
    this.id = "12";
    this.url = "/ai/carousels/basic-12";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Jon Snow",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@ordiggs",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#000000",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#FEC84B",
        },
        {
          label: "Secondary Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#ffffff",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "IBM Plex Sans Condensed",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "IBM Plex Sans",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "HOW TO WRITE PRODUCT DESCRIPTION BETTER.",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Excepteur sint occaecat cupidatat non proident`,
            max_words: 25,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "UNDERSTAND WHAT IT IS YOU'RE SELLING",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `If there's a similar product on the market, what's being listed as a benefit on that product?

Does yours offer the same benefit?
            
You need to know why your customers are buying it. Do your research and understand everything about the product you're selling.`,
            max_words: 25,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "UNDERSTAND WHAT'S UNIQUE ABOUT YOUR PRODUCT",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Duis aute irure dolor in reprehenderit.
            
Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusan tium.

Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.`,
            max_words: 25,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "UNDERSTAND WHO YOU'RE SELLING TO",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Duis aute irure dolor in reprehenderit in voluptate.
            
Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusan tium doloremque laudantium.

Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.`,
            max_words: 25,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "SHARE YOUR THOUGHTS IN THE COMMENTS",
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getBackgroundColorVariant(common_settings) {
    return this.getBackgroundColor(common_settings) + "20";
  }

  getBackgroundColorVariantSecond(common_settings) {
    return this.getBackgroundColor(common_settings) + "40";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "IBM Plex Sans Condensed";
  }

  getSecondaryFont(common_settings) {
    return common_settings.elements[7]?.value || "IBM Plex Sans";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute w-full h-full inset-x-0 px-[30px] top-0 flex items-center justify-center">
          <div className="flex flex-col items-center justify-center gap-[32px]">
            <div className="flex items-center justify-center">
              <img
                className="object-cover w-[96px] h-[96px] rounded-full"
                src={
                  commonSettings.elements[1].value.image
                    ? commonSettings.elements[1].value.image
                    : LogoPlaceholder
                }
                alt=""
              />
            </div>

            <div
              className="text-[36px] text-center font-bold leading-[36px]"
              style={{
                color: this.getSecondaryColor(commonSettings),
                fontFamily: this.getPrimaryFont(commonSettings),
              }}
            >
              {slide.elements[0]?.style ? (
                <MultilineView
                  element={slide.elements[0]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[0]?.value} />
              )}
            </div>
            <div className="flex items-center justify-center">
              <svg
                width="98"
                height="20"
                viewBox="0 0 98 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.8633 10.2715C20.8029 12.8956 19.7533 15.3646 17.6277 17.3557C16.6557 18.2662 15.5328 18.9393 14.2825 19.3929C12.9139 19.8904 11.4532 20.0826 10.0026 19.9559C8.55197 19.8292 7.14658 19.3867 5.88484 18.6595C5.78775 18.6036 5.70928 18.6213 5.61765 18.6548C4.43813 19.0849 3.25861 19.5167 2.07735 19.9408C1.72697 20.0665 1.40415 19.9904 1.13994 19.7286C0.872 19.463 0.796014 19.1375 0.92365 18.7815C1.35275 17.5835 1.78632 16.3871 2.22435 15.1924C2.23843 15.1587 2.24398 15.1221 2.24051 15.0857C2.23705 15.0494 2.22467 15.0144 2.20449 14.984C1.77595 14.2471 1.44593 13.457 1.22288 12.6342C0.934744 11.591 0.820392 10.5074 0.884416 9.42699C1.01487 7.27478 1.75726 5.36025 3.1116 3.68341C4.19751 2.34179 5.5516 1.35223 7.1555 0.712482C8.53102 0.160784 10.0126 -0.075481 11.4914 0.021055C15.3188 0.256582 18.6795 2.67595 20.1265 6.24166C20.6147 7.44389 20.8531 8.69681 20.8633 10.2715Z"
                  fill={this.getPrimaryColor(commonSettings)}
                />
                <path
                  d="M56.0886 0.45459C53.0488 0.45459 51.3636 2.62897 51.3636 2.62897C51.3636 2.62897 49.6783 0.45459 46.6385 0.45459C43.4486 0.45459 40.8635 3.01598 40.8635 6.17663C40.8635 10.516 46.0211 14.7212 47.4586 16.0498C49.1144 17.5791 51.3636 19.5454 51.3636 19.5454C51.3636 19.5454 53.6127 17.5791 55.2685 16.0498C56.706 14.7212 61.8636 10.516 61.8636 6.17663C61.8636 3.01598 59.2785 0.45459 56.0886 0.45459Z"
                  fill={this.getPrimaryColor(commonSettings)}
                />
                <path
                  d="M97.1367 18.4153C97.1367 18.8843 96.6036 19.1543 96.2255 18.8769L89.839 14.1911C89.6374 14.0433 89.3632 14.0433 89.1617 14.1911L82.7752 18.8769C82.3971 19.1543 81.864 18.8843 81.864 18.4153V1.0271C81.864 0.710912 82.1203 0.45459 82.4365 0.45459H96.5642C96.8803 0.45459 97.1367 0.710912 97.1367 1.0271V18.4153Z"
                  fill={this.getPrimaryColor(commonSettings)}
                />
              </svg>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 px-[30px] top-[51px] flex flex-col gap-[16px]">
          <div
            className="text-[36px] text-center font-bold leading-[36px]"
            style={{
              color: this.getPrimaryColor(commonSettings),
              fontFamily: this.getPrimaryFont(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="text-[16px] leading-[24px] text-center"
            style={{
              color: this.getSecondaryColor(commonSettings),
              fontFamily: this.getSecondaryFont(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 px-[30px] top-[51px] flex flex-col gap-[16px]">
          <div
            className="text-[48px] text-center font-bold leading-[48px]"
            style={{
              color: this.getPrimaryColor(commonSettings),
              fontFamily: this.getPrimaryFont(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="text-[24px] leading-[32px] text-center"
            style={{
              color: this.getSecondaryColor(commonSettings),
              fontFamily: this.getSecondaryFont(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
          <div className="flex flex-col items-center justify-center mt-[16px]">
            <img
              className="object-cover w-[64px] h-[64px] rounded-full"
              src={
                commonSettings.elements[1].value.image
                  ? commonSettings.elements[1].value.image
                  : LogoPlaceholder
              }
              alt=""
            />
            <p
              className="text-[20px] font-semibold"
              style={{ color: this.getPrimaryColor(commonSettings) }}
            >
              {commonSettings.elements[0].value}
            </p>
          </div>
        </div>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getSecondaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        <div className="absolute inset-x-0 bottom-0 top-[404px] left-[168px]">
          <div className="w-full flex items-end justify-between gap-6">
            {index !== 0 && index !== carouselLength - 1 && (
              <div
                className="inline-flex items-center justify-center w-[64px] h-[64px] rounded-full relative"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                }}
              >
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M48.6111 20.4922L61.3889 33.27L48.6111 46.0477"
                    stroke={this.getPrimaryColor(commonSettings)}
                    strokeWidth="2.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M61.3889 33.27H2.61108"
                    stroke={this.getPrimaryColor(commonSettings)}
                    strokeWidth="2.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Basic12;
